<template>
  <WhaleEmpty
    :title="title"
    :description="description"
    :size="size"
    :variant="variant"
    :action-text="actionText"
    :secondary-action-text="secondaryActionText"
    :compact="compact"
    :bordered="bordered"
    @action="$emit('action')"
    @secondary-action="$emit('secondary-action')"
  >
    <template v-if="$slots.icon" #icon>
      <slot name="icon" />
    </template>
    <template v-if="$slots.action" #action>
      <slot name="action" />
    </template>
    <slot />
  </WhaleEmpty>
</template>

<script setup>
import WhaleEmpty from '@/components/common/WhaleEmpty.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '暂无相关数据',
  },
  size: {
    type: String,
    default: 'medium',
  },
  variant: {
    type: String,
    default: 'default',
  },
  actionText: {
    type: String,
    default: '',
  },
  secondaryActionText: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
  bordered: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['action', 'secondary-action']);
</script>
